module.exports = __webpack_public_path__ + "static/media/goodfield-vinyl.be961d03.png";